/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ExternalVerificationInfoDto } from '../models/external-verification-info-dto';
import { getExternalVerificationInfo } from '../fn/user-profile/get-external-verification-info';
import { GetExternalVerificationInfo$Params } from '../fn/user-profile/get-external-verification-info';
import { getUserProfile } from '../fn/user-profile/get-user-profile';
import { GetUserProfile$Params } from '../fn/user-profile/get-user-profile';
import { patchUserProfile } from '../fn/user-profile/patch-user-profile';
import { PatchUserProfile$Params } from '../fn/user-profile/patch-user-profile';
import { resendVerificationMail } from '../fn/user-profile/resend-verification-mail';
import { ResendVerificationMail$Params } from '../fn/user-profile/resend-verification-mail';
import { UserProfileDto } from '../models/user-profile-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserProfileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserProfile()` */
  static readonly GetUserProfilePath = '/api/user-profile';

  /**
   * Gets the user-profile of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileDto>> {
    return getUserProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the user-profile of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: GetUserProfile$Params, context?: HttpContext): Observable<UserProfileDto> {
    return this.getUserProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileDto>): UserProfileDto => r.body)
    );
  }

  /** Path part for operation `patchUserProfile()` */
  static readonly PatchUserProfilePath = '/api/user-profile';

  /**
   * Updates the users profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchUserProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchUserProfile$Response(params: PatchUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileDto>> {
    return patchUserProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the users profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchUserProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchUserProfile(params: PatchUserProfile$Params, context?: HttpContext): Observable<UserProfileDto> {
    return this.patchUserProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileDto>): UserProfileDto => r.body)
    );
  }

  /** Path part for operation `getExternalVerificationInfo()` */
  static readonly GetExternalVerificationInfoPath = '/api/user-profile/external-verification-info';

  /**
   * Gets information about an active external verification of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExternalVerificationInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExternalVerificationInfo$Response(params: GetExternalVerificationInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalVerificationInfoDto>> {
    return getExternalVerificationInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets information about an active external verification of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExternalVerificationInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExternalVerificationInfo(params: GetExternalVerificationInfo$Params, context?: HttpContext): Observable<ExternalVerificationInfoDto> {
    return this.getExternalVerificationInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExternalVerificationInfoDto>): ExternalVerificationInfoDto => r.body)
    );
  }

  /** Path part for operation `resendVerificationMail()` */
  static readonly ResendVerificationMailPath = '/api/user-profile/resend-verification-mail';

  /**
   * Resends the verification mail for the currently requested/active verification of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resendVerificationMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendVerificationMail$Response(params?: ResendVerificationMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resendVerificationMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Resends the verification mail for the currently requested/active verification of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resendVerificationMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendVerificationMail(params?: ResendVerificationMail$Params, context?: HttpContext): Observable<void> {
    return this.resendVerificationMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
